import { Component, Input } from '@angular/core';
import * as _ from 'lodash';

import { ContextualActionComponent } from './contextual-action.component';
import { PST, PACT, SACT } from './pim-config';

@Component({
  moduleId: module.id,
  selector: 'pim-catalog-action',
  templateUrl: 'pim-catalog-action.component.html',
  styleUrls: [
    'contextual-action.component.scss',
    'pim-catalog-action.component.scss'
  ],
})
export class PimCatalogActionComponent extends ContextualActionComponent {

  @Input() availableStatuses: Array<number> = [];

  primaryActions = [
    {
      id: PACT.PUBLISH.id,
      action: PACT.PUBLISH.name,
      icon: PACT.PUBLISH.icon,
      type: 'update-status',
      title: 'Publish',
      active: true,
      separated: true,
      meta: {
        statusId: PACT.PUBLISH.id
      }
    },
    {
      id: PACT.APPROVE.id,
      action: PACT.APPROVE.name,
      type: 'update-status',
      title: 'Approve',
      icon: PACT.APPROVE.icon,
      active: true,
      meta: {
        statusId: PST.APPROVED.id
      }
    },
    {
      id: PACT.REVIEW.id,
      action: PACT.REVIEW.name,
      type: 'update-status',
      title: 'Set to Review',
      icon: PACT.REVIEW.icon,
      active: true,
      meta: {
        statusId: PST.REVIEW.id
      }
    },
    {
      id: PACT.DRAFT.id,
      action: PACT.DRAFT.name,
      type: 'update-status',
      title: 'Set to Draft',
      icon: PACT.DRAFT.icon,
      active: true,
      meta: {
        statusId: PST.DRAFT.id
      }
    },
  ];

  archiveAction: any = {
    id: PACT.ARCHIVE.id,
    action: PACT.ARCHIVE.name,
    type: 'archive',
    title: 'Archive selected',
    active: true,
    meta: {
      statusId: PACT.ARCHIVE.id
    }
  };

  exportSelectedAction: any = {
    id: PACT.EXPORT_SELECTED.id,
    action: PACT.EXPORT_SELECTED.name,
    type: 'export-selected',
    title: 'Export selected',
    active: true,
  };

  copySelectedAction: any = {
    id: PACT.COPY_SELECTED.id,
    action: PACT.COPY_SELECTED.name,
    type: 'copy-selected',
    title: 'Copy selected',
    active: true,
  };

  get availablePrimaryActions(): Array<any> {

    /*
      - Loope through available statuses.
      - foreach status, turn off the actions that are not available
    */

    // status = 0 - DRAFT
    // status = 1 - REVIEW
    // status = 2 - APPROVED
    if (!this.availableStatuses) { return []; }

    const newActions: any = {}; // new actions for updating avaliable primary actions

    if (this.availableStatuses.length === 1) {
    // if only one item selected
      switch (this.availableStatuses[0]) {
        case PST.DRAFT.id:
          // DRAFT – "Set to Review"
          newActions[PACT.REVIEW.name] = true;
          break;
        case PST.REVIEW.id:
          // REVIEW – "Set to Draft" | "Approve"
          newActions[PACT.DRAFT.name] = true;
          newActions[PACT.APPROVE.name] = true;
          break;
        case PST.APPROVED.id:
          // APPROVED – "Set to Draft" | "Publish"
          newActions[PACT.DRAFT.name] = true;
          newActions[PACT.PUBLISH.name] = true;
          break;
      }
    } else {
      // what statuses selected items have
      const hasDraft = this.availableStatuses.indexOf(PST.DRAFT.id) >= 0;
      const hasReview = this.availableStatuses.indexOf(PST.REVIEW.id) >= 0;
      const hasApproved = this.availableStatuses.indexOf(PST.APPROVED.id) >= 0;

      // new statuses - always can be set to DRAFT
      newActions[PACT.DRAFT.name] = true;

      if (hasDraft && hasReview && !hasApproved) {
        // DRAFT & REVIEW – "Set to Draft" | "Set to Review"
        newActions[PACT.REVIEW.name] = true;
      }
      if (!hasDraft && hasReview && hasApproved) {
        // REVIEW / APPROVED - "Set to Draft" | "Set to Approved"
        newActions[PACT.APPROVE.name] = true;
      }
    }
    this.updatePrimaryActionStatuses(newActions);
    return _.filter(this.primaryActions, 'active');
  }

  get availableSecondaryActions(): Array<any> {
    if (!this.availableStatuses) { return []; }

    const newActions: any = {};
    if (this.availableStatuses.length === 1) {
      // if only one item selected - "View details" | "Edit selected"
      newActions[SACT.VIEW_DETAILS.name] = true;
      newActions[SACT.EDIT_SELECTED.name] = true;
    } else {
      // if multimle items selected - "View selected" | "Bulk edit"
      newActions[SACT.VIEW_SELECTED.name] = true;
      newActions[SACT.BULK_EDIT.name] = true;
    }
    this.updateSecondaryActionStatuses(newActions);
    return _.filter(this.secondaryActions, 'active');
  }

  // handlers:
  onSelectedChange(action: any) {
    this.actionSelected.emit(action);
  }

  onBulkEditClick() {
    this.emitSelectedAction(this.secondaryActions[3]);
  }

  // private:
  // statuses: {
  //  ACTION_1: STATUS_1,
  //  ACTION_2: STATUS_2,
  // ...
  // }
  private updatePrimaryActionStatuses(statuses: any): void {
    this.updateActionStatuses(statuses, this.primaryActions);
  }

  private updateSecondaryActionStatuses(statuses: any): void {
    this.updateActionStatuses(statuses, this.secondaryActions);
  }

  private updateActionStatuses(statuses: any, actions: any): void {
    _.forEach(actions, (action: any) => {
      action.active = statuses[action.action] ? statuses[action.action] : false;
    });
  }
}
